import { Tag, ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { PRICE_LIST } from "@/data/content";
import { useAnchorNav } from "@/lib/nav";

const PriceList = () => {
  const go = useAnchorNav();
  return (
    <section id="priser" className="bg-navy2 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>Prislista</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Tydliga priser utan överraskningar
          </h2>
          <p className="mt-4 text-base text-cream/60 sm:text-lg">
            Se vad våra tjänster kostar – eller boka ett kostnadsfritt möte för en skräddarsydd offert.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 rounded-2xl border border-white/10 bg-navy p-6 sm:p-8" data-testid="price-list">
            <h3 className="flex items-center gap-2.5 font-display text-lg font-bold text-white">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal text-cream">
                <Tag size={18} aria-hidden="true" />
              </span>
              Individuella priser
            </h3>
            <ul className="mt-5 grid gap-x-10 lg:grid-cols-2 lg:divide-y-0">
              {PRICE_LIST.map((r) => (
                <li key={r.name} className="flex items-baseline justify-between gap-3 border-b border-white/10 py-3">
                  <span className="text-sm font-medium text-cream/85 sm:text-base">{r.name}</span>
                  <span aria-hidden="true" className="mx-1 hidden flex-1 border-b border-dotted border-white/15 sm:block" />
                  <span className="whitespace-nowrap font-display text-sm font-bold text-orange">{r.price}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
            <p className="text-sm text-cream/50">Priserna kan variera beroende på projektets omfattning och behov.</p>
            <a
              href="#kontakt"
              data-testid="pricelist-cta-link"
              onClick={(e) => go(e, "kontakt")}
              className="inline-flex items-center gap-2 font-display text-sm font-bold text-orange2 transition-colors hover:text-cream"
            >
              Begär en offert <ArrowRight size={16} aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PriceList;
